import { useState } from 'react';
import useApi from '../useApis';
import { toast } from 'react-toastify';

const useStats = () => {
  const api = useApi();
  const [statistics, setStatistics] = useState(null);
  const [graphView, setGraphView] = useState(null);
  const [patientFlow, setPatientFlow] = useState(null);
  const [ageGroup, setAgeGroup] = useState([]);
  const getStatistics = async (params, onCancel) => {
    const response = await api?.getAllStats(params);
    if (response?.data?.headers?.code === 200) {
      setStatistics(response?.data?.body);
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
  };

  const getGraphView = async (params, onCancel) => {
    const response = await api?.getGraphView(params);
    if (response?.data?.headers?.code === 200) {
      setGraphView(response?.data?.body?.data);
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
  };

  const getPatientFlow = async (params, onCancel) => {
    const response = await api?.getPatientFlow(params);
    if (response?.data?.headers?.code === 200) {
      setPatientFlow(response?.data?.body?.data);
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
  };
  const getAgeGroupChart = async (params, onCancel) => {
    const response = await api?.getAgeGroupChart(params);
    if (response?.data?.headers?.code === 200) {
      setAgeGroup(response?.data?.body?.data);
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
  };
  //this api also use for set password or pin code in first time
  return {
    statistics,
    getStatistics,
    getGraphView,
    graphView,
    getPatientFlow,
    patientFlow,
    getAgeGroupChart,
    ageGroup
  };
};

export default useStats;

// infant=> 0 - 4;
// young =>
